import { getExportData, getRemediationList, getRemediationListCnt } from './remediation_common_func';

type RemediationProps = {
  tenant: any;
  data: any;
  func: any;
  searchVal: string;
  pageNo: number;
  setTotalPages?: any;
  setTotalRecords?: any;
  isFilter?: boolean;
  dropDownValue1?: any
  setIsFilter?: any
  isRefresh: boolean;
  setRefresh: any;
  setExportDetails: any;
  setRefreshToast?: any;
  filterArray?: any;
  exportBtnClicked: boolean;
  setExportBtnClicked: any;
  assignmentType?: string;
  loading?: boolean;
  setRecordState?: any
}

const Remediation_func = (props: RemediationProps) => {
  let automationTypes: string | string[] = '';

  if (props.assignmentType === 'remediation') {
    automationTypes = ['selfhelp', 'proactive', 'scheduler', 'autoheal'];
  } else if (props.assignmentType === 'survey') {
    automationTypes = 'userSurvey';
  } else if (props.assignmentType === 'policy') {
    automationTypes = 'policy';
  } else if (props.assignmentType === 'conditionalaccess') {
    automationTypes = 'app policy';
  } else if (props.assignmentType === 'default_dart') {
    automationTypes = 'default_dart';
  }

  if (props.searchVal?.length > 0 && props.searchVal !== '') {
    getRemediationList({ search: props.searchVal, function: 'search', types: automationTypes }, 50, props.pageNo, props.func);

    getRemediationListCnt({ search: props.searchVal, function: 'search', types: automationTypes }, props.setTotalRecords, props.setTotalPages);
  } else if (props.isFilter === true) {
    const whereCondition = { filter: props.filterArray, function: 'filter', types: automationTypes };

    getRemediationList(whereCondition, 50, props.pageNo, props.func);
    getRemediationListCnt(whereCondition, props.setTotalRecords, props.setTotalPages);
  } else if (props.exportBtnClicked) {
    getExportData({ types: automationTypes, function: 'export', tenant: props.tenant }, props.setExportDetails);
  } else if (props?.loading) {
    getRemediationList({ types: automationTypes }, 50, props.pageNo, props.func);
    getRemediationListCnt({ types: automationTypes }, props.setTotalRecords, props.setTotalPages);
  }
}

export { Remediation_func }